export const toPDF = (id) => {
  var authData, token, params1, url, tempForm, k, opt
  token = window.localStorage.getItem('webToken')
  let baseUrl = window.location.protocol + '//' + window.PROJECT_CONFIG.PDF_URL
  // 'http://pdfreader-fxcloud.devx.fzyun.io'
  // 'http://pdfreader-fxcloud.textx.fzyun.cn'
  params1 = {
    fl: id,
    userId: localStorage.getItem('username') || '',
    limitRead: 'authData.hasAuth' ? '0' : '1',
    // 0全读 1试读
    token: token
  }
  // let url = 'http://www.baomi.org.cn/pdfreader/getView?pdfId=' +
  // http://172.19.206.184:8086/getView?token=123&userId=18937196209&pdfId=001&limitRead=0&t=
  url =
    baseUrl + '/getView?pdfId=' + params1.fl + '&userId=' + params1.userId + '&limitRead=' + params1.limitRead + '&token=' + params1.token + '&t=' + encodeURI('this.bookPdf.name') ||
    encodeURI('PDF阅读')
  console.log(url, 'url487')
  tempForm = document.createElement('form')

  tempForm.action = url
  tempForm.method = 'post'
  tempForm.style.display = 'none'
  tempForm.target = '_blank'

  for (k in params1) {
    opt = document.createElement('textarea')
    opt.name = k
    opt.value = params1[k]
    tempForm.appendChild(opt)
  }

  document.body.appendChild(tempForm)
  tempForm.submit() // 提交表单
}
